<template>
    <div>
        <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
            <div style="display: flex; align-items: center; flex-grow: 1;"></div>
            <export-components v-if="['ADMIN', 'MANAGER'].includes(role)" :apiFunction="exportContract"
                :requestData="getSearch({...sendData[activeTab]})" :option="option" @sendData=getSearchData></export-components>
        </div>
        <el-tabs v-model="activeTab" @tab-click="changeTab">
            <el-tab-pane v-for="(item, tabIndex) in data" :label="item.label" :name="item.name" :key="tabIndex">
                <span slot="label" v-if="item.showBadge">
                    <el-badge style="margin-top: 10px;margin-bottom: 10px"
                        :value="pageTotal[item.name] === 0 ? '' : pageTotal[item.name]" :max="99">{{ item.label }}</el-badge>
                </span>
            </el-tab-pane>
        </el-tabs>
        <el-tabs v-if="classList?.[activeTab]?.length > 0" v-model="activeName[activeTab]" @tab-click="changeTab">
            <el-tab-pane v-for="(item, index) in classList[activeTab]" :label="item.label" :name="item.name"
                :key="activeTab + index">
                <span slot="label" v-if="item.showBadge">
                    <el-badge style="margin-top: 10px;margin-bottom: 30px"
                        :value="pageTotal[item.name] === 0 ? '' : pageTotal[item.name]" :max="99">{{ item.label }}</el-badge>
                </span>
            </el-tab-pane>
        </el-tabs>
        <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection($event)"
            @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true"
            :table-col-check="{ isShow: true, name: 'ContractAudit3' + activeTab }" ref="wMyTable"
            :key="activeTab" :isShowRowSelection="true" :page="page"
            @pageChange="handlePagePagination($event, page)">
            <div slot="operation" slot-scope="{text,record}">
                <el-button size="mini" type="success" v-if="record.status !== 'APPLYING' || isAuditViewOnly"
                    @click="handleDetails(record)">查看详情</el-button>
                <el-button size="mini" type="primary" v-if="record.status === 'APPLYING' && !isAuditViewOnly"
                    @click="handleEdit(record)">审核</el-button>
                <el-button size="mini" type="primary" color="#ffffff"
                    v-if="record.contractFilePath && record.status !== 'APPLYING'" icon="el-icon-download"
                    @click="download(record)">下载合同</el-button>
            </div>
            <div slot="executeContractNumber" slot-scope="{text,record}">
                <div v-if="text">
                    <span>{{ text }}</span>
                    <el-tooltip content="复制">
                        <a-icon type="copy" style="color: #3f9dfe" @click="copyData(text)" />
                    </el-tooltip>
                </div>
                <span v-else>{{ 'NA' }}</span>
            </div>
            <div slot="invoicedAmount" slot-scope="{text,record}">
                <span v-if="['PREPAYMENTS', 'FORMAL', 'IMPORT_PREPAYMENTS'].includes(record.contractType)">{{ text }}</span>
                <span v-else>{{ 'NA' }}</span>
            </div>
            <div slot="addedAmount" slot-scope="{text,record}">
                <span v-if="['PREPAYMENTS', 'IMPORT_PREPAYMENTS'].includes(record.contractType)">{{ text }}</span>
                <span v-else>{{ 'NA' }}</span>
            </div>
            <div slot="contact" slot-scope="{text,record}">
                <el-tooltip effect="dark" content="查看客户信息" placement="bottom" v-if="text">
                    <el-link type="primary" :underline="false" @click="showContact(record)"><i
                            v-html="viewDetailIcon"></i></el-link>
                </el-tooltip>
                <span>{{ text }}</span>
            </div>
            <div slot="contractNumber" slot-scope="{text,record,index,column}">
                <span>{{ text }}</span>
                <el-tooltip content="复制">
                    <a-icon type="copy" style="color: #3f9dfe" @click="copyData(text)" />
                </el-tooltip>
            </div>
            <div slot="filterContractType" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 15px 15px 0">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='预付款'>预付款</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='正式'>正式</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='扣款'>扣款</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='老系统预付款'>老系统预付款</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='研发'>研发</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters)">搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </div>
            <div slot="status" slot-scope="{text,record}">
                <span style="display: flex;align-items: center">
                    <el-tag :type="getStatusColor(text, 'tagType')"
                        :style="{ color: getStatusColor(text, 'color'), 'background-color': getStatusColor(text, 'backgroundColor') }">
                        {{ getStatusColor(text, 'name') }}</el-tag>
                    <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look"
                        :text="record['rejectionReason']" :column="{ title: '驳回原因' }" :onlyDetail="true"
                        :isOpenHtml="false">
                    </w-ellipsis-and-look>
                </span>
            </div>
            <div slot="contractType" slot-scope="{text,record}">
                <el-tag :type="getContractColor(text, 'tagType')" :style="{
                    color: getContractColor(text, 'color'),
                    'background-color': getContractColor(text, 'backgroundColor'),
                    'border-color': getContractColor(text, 'borderColor')
                }">
                    {{ getContractColor(text, 'name') }}</el-tag>
            </div>
            <div slot="impairmentFlag" slot-scope="{text,record}"
                style="display: flex;align-items: center;justify-content: center;">
                <el-tag v-if="text === 0" type="danger">否</el-tag>
                <span v-else-if="text === 1" style="display: flex;align-items: center">
                    <el-tag type="success">是</el-tag>
                    <el-tooltip effect="dark" style="margin-left:5px" content="查看转预付款信息" placement="bottom">
                        <el-link type="primary" :underline="false" @click="showImpairment(record)"><i
                                v-html="viewDetailIcon"></i></el-link>
                    </el-tooltip>
                </span>
            </div>
            <div slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 15px 15px 0">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='待审核'>待审核</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='已通过'>已通过</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='已驳回'>已驳回</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters)">搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </div>
            <div slot="filterFlag" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 15px 15px 0">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='是'>是</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='否'>否</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters)">搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </div>
            <div slot="rawDataReleaseStatus" slot-scope="{text,record}">
                <div v-if="text" class="status-tag-container">
                    <el-tag v-if="text === 'ALL_RELEASE'" type="success">已释放</el-tag>
                    <el-tag v-else-if="text === 'PARTIAL_RELEASE'" type="primary">部分释放</el-tag>
                    <el-tag v-else-if="text === 'NOT_RELEASED'" type="warning">未释放</el-tag>
                </div>
                <div v-else class="status-tag-container">
                    <el-tag type="info">NA</el-tag>
                </div>
            </div>
            <div slot="contractName" slot-scope="{text,record,index,column}">
                <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
            </div>
            <div slot="filterRawDataReleaseStatus"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
                style="padding: 8px; position: relative; z-index: 9999 !important;">
                <div style="padding: 15px 15px 0">
                    <el-radio-group v-model="selectedKeys[0]">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='未释放'>未释放</el-radio>
                            </el-col>
                            <el-col :span="12">
                                <el-radio label='部分释放'>部分释放</el-radio>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-radio label='已释放'>已释放</el-radio>
                            </el-col>
                        </el-row>
                    </el-radio-group>
                </div>
                <div style="display: flex;padding: 15px">
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters)">
                        搜索
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
                    </a-button>
                </div>
            </div>
        </w-table>
        <picture-loading v-if="loading"></picture-loading>
        <contract-details v-if="showDetailsDialog" :show-dialog="showDetailsDialog" :select-detail="[showDetails]"
            @submit="close"></contract-details>
        <details-audit-dialog v-if="showCheckDialog" :show-dialog="showCheckDialog" :contract-detail="contractDetail"
            :analysis-flag="false" :record-detail="recordDetail" @submit="closeCheckDialog"></details-audit-dialog>
        <customer-user-info :show-dialog="showContactInfo" v-if="showContactInfo" :select-detail="contactInfo"
            @submit="closeShowContact"></customer-user-info>
        <impairment-info :show-dialog="showImpairmentInfo" v-if="showImpairmentInfo" :select-detail="impairmentInfo"
            @submit="closeShowImpairment"></impairment-info>
    </div>
</template>

<script>
import { exportContract, getContractPage } from "@/api/dilivery/sales/contract";
import { contractChecks } from "@/utils/data/tableCol/check/contract/contractChecks";
import ContractDetails from "@/components/sales/ContractDetails.vue";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import ExFoldTable from "@/components/ExFoldTable.vue";
import { getRecordPage } from "@/api/dilivery/record";
import DetailsAuditDialog from "@/components/check/DetailsAuditDialog.vue";
import { tableOperationMixin } from "@/mixins/tableOperation";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import _ from "lodash";
import ExportComponents from "@/components/ExportComponents.vue";
import { getContractColor, getStatusColor } from "@/color";
import { copyText } from "@/utils/windowsUtils";
import { viewDetailIcon } from "@/utils/icon";
import CustomerUserInfo from "@/components/customer/CustomerUserInfo.vue";
import ImpairmentInfo from "@/components/impairment/ImpairmentInfo.vue";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { auditViewOnlyMixin } from "@/mixins/auditViewOnlyMixin";
const baseURL = process.env.VUE_APP_BASE_API
const baseWs = process.env.VUE_APP_BASE_WS

export default {
    name: "ContractAudit",
    components: {
        ImpairmentInfo,
        CustomerUserInfo, ExportComponents, PictureLoading, DetailsAuditDialog, ExFoldTable, TableHeadNote, ContractDetails
    },
    mixins: [tableOperationMixin, auditViewOnlyMixin],
    data() {
        return {
            contactInfo: [],
            role: '',
            showContactInfo: false,
            impairmentInfo: {},
            showImpairmentInfo: false,
            loading: true,
            activeTab: 'APPLYING',
            activeName:{
                APPLYING:'APPLYING_ALL'
            },
            tableData: [],
            selectable: [],
            searchConditionTag: [],//搜索tag
            sortConditionTag: [],
            page: {
                pageSize: 10,
                currentNum: 1,
                total: null
            },
            data: [
                {
                    label: '全部',
                    name: 'ALL',
                    showBadge: false,
                },
                {
                    label: '待审核',
                    name: 'APPLYING',
                    showBadge: true,
                },
                {
                    label: '已通过',
                    name: 'SUCCESS',
                    showBadge: false,
                },
                {
                    label: '已驳回',
                    name: 'DEFEAT',
                    showBadge: false,
                },
            ],
            classList:{
                APPLYING:[
                    {
                        label: '全部',
                        name: 'APPLYING_ALL',
                        showBadge: true,
                    },
                    {
                        label: '已收样',
                        name: 'APPLYING_SampleReceived',
                        showBadge: true,
                    },
                    {
                        label: '团队费用',
                        name: 'APPLYING_TEAM',
                        showBadge: true,
                    },
                ]
            },
            viewDetailIcon: viewDetailIcon,
            option: [
                { label: '合同审核时间', value: 'operatingTime' },
                { label: '合同拟定时间', value: 'contractDraftingDate' },
                { label: '创建时间', value: 'createTime' },
            ],
            sendData:{
                ALL:{
                    auditFlag: true,
                    "query#contractType.NE": "ADVANCE_PAYMENT_TRANSFER",
                    "query#status.IN": "APPLYING,SUCCESS,DEFEAT",
                },
                APPLYING:{
                    auditFlag: true,
                    "query#contractType.NE": "ADVANCE_PAYMENT_TRANSFER",
                    "query#status.EQ": "APPLYING",
                },
                SUCCESS:{
                    auditFlag: true,
                    "query#contractType.NE": "ADVANCE_PAYMENT_TRANSFER",
                    "query#status.EQ": "SUCCESS",
                },
                DEFEAT:{
                    auditFlag: true,
                    "query#contractType.NE": "ADVANCE_PAYMENT_TRANSFER",
                    "query#status.EQ": "DEFEAT",
                },
                APPLYING_ALL:{
                    auditFlag: true,
                    "query#contractType.NE": "ADVANCE_PAYMENT_TRANSFER",
                    "query#status.EQ": "APPLYING",
                },
                APPLYING_SampleReceived:{
                    auditFlag: true,
                    "query#contractType.NE": "ADVANCE_PAYMENT_TRANSFER",
                    "query#status.EQ": "APPLYING",
                    "pendingSampleFlag": false
                },
                APPLYING_TEAM:{
                    auditFlag: true,
                    "query#contractType.EQ": "TEAM",
                    "query#status.EQ": "APPLYING"
                }
            },
            showCheckDialog: false, //控制正式合同增加页面显示与隐藏
            contractDetail: {},
            recordDetail: {},
            showDetailsDialog: false,
            showDetails: '',
            pageTotal: {
                ALL: 0,
                APPLYING: 0,
                SUCCESS: 0,
                DEFEAT: 0,
                APPLYING_ALL: 0,
                APPLYING_SampleReceived: 0,
                APPLYING_TEAM: 0
            },
        }
    },
    computed: {
        columns() {
            let cols = contractChecks([] || {})
            if (this.activeTab === "APPLYING") {
                cols = cols.filter(item => !['impairmentFlag', 'operatingPersonName', 'operatingTime'].includes(item.key))
            }
            return JSON.parse(JSON.stringify(cols))
        }
    },
    mounted() {
        this.getData()
        this.loadContractData() 
    },
    created() {
        this.role = getDataInLocalStorage("role")
    },
    methods: {
        loadContractData() {
            // 销售侧角色（SALES_MANAGER、SALES）仅查看详情，不发起标签页红点数量查询
            if (this.isAuditViewOnly) return
            // 获取所有标签页的数据
            const tabs = ['APPLYING','APPLYING_ALL', 'APPLYING_SampleReceived', 'APPLYING_TEAM'];
            // 获取主标签页数据
            tabs.forEach(tab => {
                this.getTabData(tab);
            });
        },
        getTabData(tabName) {
            let params = {
                'page.current': 1,
                'page.size': 10,
                'order': 'contractDraftingDate.asc'
            };

            let sendData = { ...this.sendData[tabName] };

            getContractPage(params, sendData).then(res => {
                if (res.code === 200) {
                    // 更新对应标签页的pageTotal
                    this.$set(this.pageTotal, tabName, parseInt(res.data.total));
                }
            }).catch(err => {
                console.log(err);
            });
        },
        getStatusColor,
        getContractColor,
        exportContract,
        //下载附件
        async download(row) {
            try {
                let url = `${baseURL}/sequencing-contract/attachment/${row.id}/CONTRACT_ANNEX?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
                const elink = document.createElement('a')
                elink.href = url
                document.body.appendChild(elink)
                elink.click()
                document.body.removeChild(elink);
            } catch (error) {
                console.log(error);
            }
        },
        getSearchData(sendData) {
            if (sendData) {
                // 更新全局搜索条件
                this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key));
                if (Object.keys(sendData).length) {
                    this.searchConditionTag.push(sendData);
                }
                if (this.$refs.wMyTable) {
                    this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
                }
                this.getData('search');
            }
        },
        changeTab() {
            this.$nextTick(() => {
                // 重置全局变量
                this.tableData = [];
                this.selectable = [];
                this.searchConditionTag = [];
                this.sortConditionTag = [];
                this.page = {
                    pageSize: 10,
                    currentNum: 1,
                    total: null
                };

                if (this.$refs.wMyTable) {
                    this.$refs.wMyTable.selectedRowKeys = [];
                    this.$refs.wMyTable.searchConditionTag = [];
                }

                this.getData();
            });
        },
        //表格的选择框
        rowSelection(selectedRows) {
            this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item =>
                this.$refs.wMyTable && this.$refs.wMyTable.selectedRowKeys &&
                this.$refs.wMyTable.selectedRowKeys.includes(item.id)
            );
        },
        showContact(row) {
            this.contactInfo = [row.customerContacts]
            this.showContactInfo = true
        },
        closeShowContact() {
            this.showContactInfo = false
        },
        showImpairment(row) {
            this.impairmentInfo = row
            this.showImpairmentInfo = true
        },
        closeShowImpairment() {
            this.showImpairmentInfo = false
        },
        copyData(text) {
            copyText(text)
            this.$messageUi.success('复制成功')
        },
        getTableSearchSortCon(ConditionTag) {
            this.searchConditionTag = ConditionTag[0];
            this.sortConditionTag = ConditionTag[1];
            this.getData('search');
        },
        // 获取数据
        getData(searchFlag) {
            this.loading = true
            let params = {
                'page.current': this.page.currentNum,
                'page.size': this.page.pageSize,
                'order': 'contractDraftingDate.asc'
            };
            if (searchFlag) {
                params = {
                    'page.current': 1,
                    'page.size': 10,
                }
            }
            if (this.sortConditionTag && this.sortConditionTag.length > 0) {
                params["order"] = this.sortConditionTag.map(sortCondition => {
                    return sortCondition.colName + "." + sortCondition.order;
                }).join(",");
            }
            let sendData = {};
            if (this.activeTab === 'APPLYING') {
                sendData = {...this.sendData[this.activeName[this.activeTab]]}
            } else {
                sendData = { ...this.sendData[this.activeTab] }
            }
            if (this.searchConditionTag && this.searchConditionTag.length) {
                //遍历搜索条件的内容
                sendData = this.getSearch(sendData)
            }
            getContractPage(params, sendData).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.tableData = res.data.records
                    // 分页赋值
                    this.page.currentNum = parseInt(res.data.current)
                    this.page.pageSize = parseInt(res.data.size)
                    this.page.total = parseInt(res.data.total)
                    // 销售侧角色不展示标签页红点数量
                    if (!this.isAuditViewOnly) {
                        if (this.activeTab === 'APPLYING') {
                            this.pageTotal[this.activeName[this.activeTab]] = parseInt(res.data.total)
                        } else {
                            this.pageTotal[this.activeTab] = parseInt(res.data.total)
                        }
                    }
                }
            }).catch(err => {
                console.log(err);
                this.loading = false
            })
        },
        getSearch(sendData) {
            let data = ['baseCompanyName', 'customerContactsName', 'salesName', 'trusteeContactsName', 'customerCompanyName'];
            ;

            this.searchConditionTag.forEach(item => {
                let value = item.value;

                if (item.key === 'contractType') {
                    if (item.value === '预付款') {
                        value = 'PREPAYMENTS';
                    } else if (item.value === '正式') {
                        value = 'FORMAL';
                    } else if (item.value === '研发') {
                        value = 'DEVELOPMENT';
                    } else if (item.value === '老系统预付款') {
                        value = 'IMPORT_PREPAYMENTS';
                    } else {
                        value = 'CHARGEBACKS';
                    }
                } else if (item.key === 'impairmentFlag') {
                    if (item.value === '是') {
                        value = 1;
                    } else {
                        value = 0;
                    }
                } else if (item.key === 'status') {
                    if (item.value === '待审核') {
                        value = 'APPLYING';
                    } else if (item.value === '已通过') {
                        value = 'SUCCESS';
                    } else if (item.value === '已驳回') {
                        value = 'DEFEAT';
                    } else if (item.value === '待评估') {
                        value = 'EVALUATING';
                    } else if (item.value === '已废弃') {
                        value = 'DERELICT';
                    } else {
                        value = 'CONTRACT_TO_BE_SUBMITTED';
                    }
                } else if (item.key === 'contractNumber') {
                    value = value.replace(/[A-Za-z]/g, "");
                } else if (item.key === 'rawDataReleaseStatus') {
                    if (item.value === '未释放') {
                        value = 'NOT_RELEASED';
                    } else if (item.value === '部分释放') {
                        value = 'PARTIAL_RELEASE';
                    } else {
                        value = 'ALL_RELEASE';
                    }
                }

                if (data.includes(item.key)) {
                    sendData[item.key] = value;
                } else if (['contractType', 'rawDataReleaseStatus'].includes(item.key)) {
                    sendData["query#" + item.key + ".EQ"] = value;
                } else if (item.key === 'sourceIntentProjectId') {
                    // 不处理
                } else if (this.option.map(it => it.value).includes(item.key)) {
                    sendData["query#" + item.key + ".BETWEEN"] = item.value;
                } else {
                    sendData["query#" + item.key + ".LIKE"] = value;
                }
            });

            return sendData;
        },
        //页码的变动
        handlePagePagination(page, pager) {
            this.page.currentNum = page.currentNum;
            this.page.pageSize = page.pageSize;
            this.getData();
        },
        async handleEdit(row) {
            try {
                const res = await getContractPage({}, { "query#id.EQ": row.id, auditFlag: true });
                if (res.code === 200 && res.data.records.length > 0) {
                    if (res.data.records[0].status !== 'APPLYING') {
                        this.$messageUi.error('该合同已审核');
                        this.getData();
                        return;
                    }
                    this.contractDetail = res.data.records[0];
                } else {
                    this.contractDetail = {};
                    this.$messageUi.error('合同数据获取失败');
                    return;
                }

                let data = {
                    "query#contractIds.FIND_IN_SET": row.id,
                    "query#status.EQ": "APPLYING",
                    auditFlag: true
                };

                const response = await getRecordPage({}, data);
                if (response.code === 200 && response.data.records.length > 0) {
                    this.recordDetail = response.data.records[0];
                } else {
                    this.recordDetail = {};
                }

                this.showCheckDialog = true;
            } catch (error) {
                console.log(error);
                this.showCheckDialog = false;
                this.$messageUi.error('打开审核页面失败');
            }
        },
        handleDetails(row) {
            this.showDetails = row
            this.showDetailsDialog = true
        },
        // 关闭审核弹出框
        closeCheckDialog(type) {
            if (type === 'confirm') {
                this.getData();
            }
            this.$nextTick(() => {
                this.showCheckDialog = false;
            });
            this.recordDetail = {};
            this.contractDetail = {};
        },
        //关闭详情弹出框
        close() {
            this.$nextTick(() => {
                this.showDetailsDialog = false
            })
        }
    }
}
</script>

<style scoped></style>
